module.exports = __webpack_public_path__ + "style/img/download.30c3df8e.jpg";